// URL da API por ambiente. Em desenvolvimento vem de .env.development
// (REACT_APP_API_URL); o valor por omissão é o de produção, para que um build
// sem configuração nunca aponte para uma máquina local.
const BASE_URL = process.env.REACT_APP_API_URL || 'https://go.api.jaf.com.pt/api';

export default BASE_URL;
